export enum ORGANIC_PRICE_VERSION {
	V1 = 'organicPricesV1',
	V2 = 'organicPricesV2',
	V3 = 'organicPricesV3',
	V4 = 'organicPricesV4',
	V5 = 'organicPricesV5',
	V6 = 'organicPricesV6',
	V7 = 'organicPricesV7',
	V8 = 'organicPricesV8',
	V9 = 'organicPricesV9',
	V10 = 'organicPricesV10',
	V11 = 'organicPricesV11',
	V12 = 'organicPricesV12',
	V13 = 'organicPricesV13',
	V14 = 'organicPricesV14',
	V15 = 'organicPricesV15',
	V16 = 'organicPricesV16',
	V17 = 'organicPricesV17',
	V18 = 'organicPricesV18',
	V19 = 'organicPricesV19',
	V20 = 'organicPricesV20',
	V21 = 'organicPricesV21',
	V22 = 'organicPricesV22',
	V23 = 'organicPricesV23',
	V24 = 'organicPricesV24',
	V25 = 'organicPricesV25',
	V26 = 'organicPricesV26',
	V27 = 'organicPricesV27',
	V28 = 'organicPricesV28',
	V29 = 'organicPricesV29',
	V30 = 'organicPricesV30',
	V31 = 'organicPricesV31',
}
